import { Avatar, Divider, Grid } from '@material-ui/core';
import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import Masks from '../../providers/Masks';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';

import avatar from '../../Pics/avatar.jpg'


export default class AnalizaLucratorilor extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            lucratoriAll: [],
            lucratoriTop3: [],
            lucratoriToDisplay: []
        }
    }

    componentDidMount() {
        this.getData()
    }

    ws = new Ws()
    u = new Utils()
    m = new Masks()
    u = new Utils()

    getData = async () => {
        let _proiecte = this.ws.customSelect('select * from proiecte where isnull(sters,0) = @p1 order by id desc', {
            p1: 0
        })

        let _taskuri = this.ws.customSelect(`select t.*, u.email,u.telefon, a.* from taskuri t left outer join useri u 
        on (t.id_utilizator_responsabil = u.id)
        left outer join angajati a on(u.id = a.id_user)
         where t.id_etapa_proiect in 
         (select id from proiecte_etape where isnull(inactiv, 0) != 1) and isnull(t.id_task_parent, 0) = 0
          and  isnull(t.inactiv,0) !=1 order by t.cand_data asc`, {
            p1: 1
        })

        let _getBugetTask = this.ws.customSelect(`select b.*, p.id as id_proiect from bugete_taskuri b left join proiecte p
        on b.id_task in (select id from taskuri where id_proiect = p.id and isnull(inactiv,0) != 1) where isnull(b.sters,0) != 1 `, {
            p1: 0
        })

        let _getCostTask = this.ws.customSelect(`select ct.*, p.id as id_proiect from costuri_taskuri ct left join proiecte p
        on ct.id_task in (select id from taskuri where id_proiect = p.id and isnull(inactiv,0) != 1) where isnull(ct.sters,0 ) != 1 `, {
            p1: 0
        })


        let [proiecte, taskuri, getBugetTask, getCostTask] = await Promise.all([_proiecte, _taskuri, _getBugetTask, _getCostTask])


        if (proiecte.Succes && taskuri.Succes && getBugetTask.Succes && getCostTask.Succes) {

            console.log('proiecte :>> ', proiecte);
            console.log('taskuri :>> ', taskuri);
            console.log('getBugetTask :>> ', getBugetTask);
            console.log('getCostTask :>> ', getCostTask);



            let proiecte2 = [...proiecte.Content]

            let taskuriC = [...taskuri.Content]

            let lucratori = [...new Set(taskuriC.map(c => c.nume))]
            let lucratoriIduri = [...new Set(taskuriC.map(c => c.id_utilizator_responsabil))]

            let lucratoriNew = []

            for (let i = 0, n = lucratori.length; i < n; i++) {


                let lucrator = {
                    id: lucratoriIduri[i],
                    nume: lucratori[i],
                    ore_lucrate: 0,
                    proiecte: 0,
                    taskuri: [],
                    expand: false
                }

                let taskuriFilter = taskuriC.filter(cc => cc.id_utilizator_responsabil === lucrator['id'])




                for (let j = 0, m = taskuriFilter.length; j < m; j++) {
                    let bugetTaskuri1 = getBugetTask.Content
                    bugetTaskuri1 = bugetTaskuri1.filter(bt => bt.id_task === taskuriFilter[j].id)

                    taskuriFilter[j]['buget'] = 0

                    for (let t = 0, n3 = bugetTaskuri1.length; t < n3; t++) {
                        taskuriFilter[j]['buget'] += bugetTaskuri1[t].valoare + (bugetTaskuri1[t].valoare * bugetTaskuri1[t].tva / 100)
                    }
                    taskuriFilter[j]['cost'] = 0

                    let costTask1 = [...getCostTask.Content].filter(cT => cT.id_task === taskuriFilter[j].id)

                    for (let cT = 0, n6 = costTask1.length; cT < n6; cT++) {

                        taskuriFilter[j]['cost'] += costTask1[cT].valoare + (costTask1[cT].valoare * costTask1[cT].tva / 100)
                    }



                    taskuriFilter[j]['profit'] = taskuriFilter[j]['buget'] - taskuriFilter[j]['cost']


                    let zileTask = this.m.jsDatesDifferenceInDays(new Date(this.u.ParseDataFromSql(taskuriFilter[j]['cand_data'])), new Date(this.u.ParseDataFromSql(taskuriFilter[j]['pana_cand_data'])))


                    taskuriFilter[j]['ore_muncite'] = zileTask * 8

                    lucrator['ore_lucrate'] += taskuriFilter[j]['ore_muncite']

                    let idxProiect = proiecte2.findIndex(pr => pr.id === taskuriFilter[j]['id_proiect'])
                    taskuriFilter[j]['nume_proiect'] = ''

                    if (idxProiect !== -1) {

                        lucrator['proiecte'] += 1

                        taskuriFilter[j]['nume_proiect'] = proiecte2[idxProiect]['titlu']

                    }

                    lucrator['functie'] = taskuriFilter[j]['functie']

                    lucrator['taskuri'].push(taskuriFilter[j])


                }

                lucratoriNew.push(lucrator)

            }


            console.log('lucratoriNew :>> ', lucratoriNew);



            let lucratoriAll = [...lucratoriNew]
            lucratoriAll = lucratoriAll.sort((a, b) => {
                if (a.profit > b.profit) {
                    return 1
                } else {
                    return -1
                }
            })

            let top3Count = 3
            let lucratoriTop3 = []

            for (let i = 0, n = lucratoriAll.length > 3 ? top3Count : lucratoriAll.length; i < n; i++) {

                lucratoriTop3.push(lucratoriAll[i])
            }

            console.log('lucratoriNew :>> ', lucratoriAll);
            console.log('lucratoriTop3 :>> ', lucratoriTop3);

            this.setState({
                lucratoriAll: lucratoriAll,
                lucratoriTop3: lucratoriTop3,
                lucratoriToDisplay: lucratoriTop3
            })

        }



    }


    numeAvatar = (nume) => {

        if(nume){
            let n = nume.split(' ')

            // console.log('n :>> ', n);
    
            let firstLetters = ''
    
            if (n[0]) {
    
                firstLetters += n[0].substring(0, 1)
    
            }
            if (n[1]) {
                firstLetters += n[1].substring(0, 1)
            }
    
            firstLetters = firstLetters.toUpperCase()
    
            return firstLetters
        }else{
            return 'NA'
        }
        

    }

    expandLucratori = (p) =>{

        let lucratori = [...this.state.lucratoriToDisplay]

        let pIdx = lucratori.findIndex(pr => pr.id === p.id);

        if(pIdx !== -1){

            lucratori[pIdx]['expand'] = !lucratori[pIdx]['expand']

            this.setState({lucratoriToDisplay:lucratori})
        }
    }


    afisazaTotiLucratorii = () =>{

        if(this.state.lucratoriToDisplay.length > 3){
            console.log('true :>> ', this.state.lucratoriTop3);
            this.setState({lucratoriToDisplay:this.state.lucratoriTop3})
        }else{

            console.log('false :>> ', this.state.lucratoriAll);
            this.setState({lucratoriToDisplay:this.state.lucratoriAll})
           
        }
    }
    render() {
        return (
            <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Grid container>
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                            <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.financiar.analizaAngajatilor} </h5>
                        </Grid>

                        <Grid style={{ paddingTop: 20, textAlign: 'right' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                            <span style={{ textAlign: 'left', paddingLefft: 20, fontSize: 14 }} >{this.dictionary.financiar.top3Angajati} </span>
                        </Grid>

                        <Grid onClick={this.afisazaTotiLucratorii} style={{ paddingTop: 20, textAlign: 'right' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                            <span style={{ textAlign: 'left', paddingLefft: 20, textDecoration: 'underline', color: '#94c3f3', fontSize: 14, cursor: 'pointer' }} >{this.dictionary.financiar.afisazaTotiAngajatii} </span>
                        </Grid>
                    </Grid>

                    <Divider className='pm-divider' />
                </Grid>


                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Grid container>
                        {this.state.lucratoriToDisplay.map((p, idx) => {

                            return (
                                <Grid style={{ marginTop: 20 }} key={idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Grid container>
                                        <Grid item xs={7} sm={7} md={7} lg={7} xl={7}>
                                            <Grid  container>

                                                <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                    {
                                                        p.poza &&
                                                        <div
                                                            className='pm-angajati-picture'

                                                            style={{ backgroundImage: `url('${p.poza ? (new Ws().adresaMedia + '/Angajati/' + p.poza) : avatar}')`, width: 36, height: 36, padding: 5 }}>

                                                        </div>
                                                    }
                                                    {!p.poza &&

                                                        <Avatar
                                                            className='pm-angajati-picture'
                                                            style={{ display: 'flex', textAlign: 'center', justifyContent: 'center', height: 28, width: 28, backgroundColor: new Utils().culoriUtilizatori(p.id), padding: 5, cursor: 'pointer' }}>
                                                            {/* <i style={{ verticalAlign: '-webkit-baseline-middle', cursor: 'pointer' }} className='material-icons'>person</i> */}
                                                            <span style={{ display: 'block' }}>{this.numeAvatar(p.nume)} </span>
                                                        </Avatar>
                                                        // <Avatar onClick={this.props.userClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(u.nume + ' ')} </Avatar>
                                                    }
                                                </Grid>

                                                <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>
                                                    <span style={{ fontWeight: 700, fontSize: 14 }}>    {p.nume}</span><br />
                                                    <span style={{
                                                        fontSize: 12,
                                                        color: '#9a9a9a'
                                                    }}>{p.functie}</span>
                                                </Grid>

                                            </Grid>
                                        </Grid>
                                       
                                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                            <Grid style={{ textAlign: 'left' }} container>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b2b2b2' }}>{this.dictionary.financiar.totalOre}</span>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{p.ore_lucrate} </span>
                                                </Grid>
                                            </Grid>

                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                            <Grid style={{ textAlign: 'left' }} container>
                                            </Grid>

                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                            <Grid style={{ textAlign: 'left' }} container>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b2b2b2' }}>{this.dictionary.financiar.proiecte}</span>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{p.proiecte}</span>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                            <Grid style={{ textAlign: 'left' }} container>
                                            </Grid>

                                        </Grid>

                                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                            <Grid style={{ textAlign: 'left' }} container>
                                                <Grid onClick={() => { this.expandLucratori(p) }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                    <i style={{ cursor: 'pointer' }} className='material-icons'>{p.expand ? 'expand_less' : 'expand_more'}</i>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    {p.expand && p.taskuri.map((t, idx2) => {
                                        return (
                                            <Grid key={idx2} style={{ marginTop: 20, paddingLeft: 10 }} container>
                                                <Grid style={{ position: 'relative' }} item xs={3} sm={3} md={3} lg={3} xl={3}>

                                                    <div style={{ position: 'absolute', width: 5, height: '100%', backgroundColor: '#c4c4c4', left: -10 }}>

                                                    </div>
                                                    <Grid style={{ textAlign: 'left' }} container>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b2b2b2' }}>{this.dictionary.financiar.proiect}</span>
                                                        </Grid>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 400, color: 'black' }}>{t.nume_proiect} </span>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                <Grid style={{ position: 'relative' }} item xs={4} sm={4} md={4} lg={4} xl={4}>

                                                    <Grid style={{ textAlign: 'left' }} container>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b2b2b2' }}>{this.dictionary.financiar.numeSarcina}</span>
                                                        </Grid>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 400, color: 'black' }}>{t.titlu} </span>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                    <Grid style={{ textAlign: 'left' }} container>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b2b2b2' }}>{this.dictionary.financiar.totalOre}</span>
                                                        </Grid>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{t.ore_muncite} </span>
                                                        </Grid>
                                                    </Grid>

                                                </Grid>
                                                <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                    <Grid style={{ textAlign: 'left' }} container>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b2b2b2' }}>{this.dictionary.financiar.rezolvat}</span>
                                                        </Grid>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                           <i style={{color:t.statusul === 'Finalizat' ? '#679422' : '#e47272' }} className='material-icons'>verified</i>
                                                        </Grid>
                                                    </Grid>

                                                </Grid>
                                                <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                    <Grid style={{ textAlign: 'left' }} container>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b2b2b2' }}>{this.dictionary.financiar.pretOra}</span>
                                                        </Grid>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{t.cost_minut} Lei</span>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                    <Grid style={{ textAlign: 'left' }} container>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b2b2b2' }}>{this.dictionary.financiar.pretTotal}</span>
                                                        </Grid>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{t.cost_minut * t.ore_muncite} Lei</span>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                          

                                                <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                    <Grid style={{ textAlign: 'left' }} container>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b2b2b2' }}></span>
                                                        </Grid>

                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        )
                                    })}

                                    <Divider style={{ marginTop: 20 }} className='pm-divider' />
                                </Grid>
                            )

                        })}

                    </Grid>
                </Grid>

                
            </Grid>
        );
    }
}